import React, { useState } from "react";

import EssayMenu from "./EssayMenu";
import EssayContent from "./EssayContent";
import EssayHero from "./EssayHero";
import { Essay } from "./Types";

import "./style/main.scss";

export default function (props: {
    match: {
        params: {
            slug?: string
        }
    }
}) {

    const [currentEssay, setCurrentEssay] = useState<Essay>();
    const [essayList, setEssayList] = useState<Array<Essay>>();

    if (!essayList) {
        fetch(`${process.env.PUBLIC_URL}/essays/index.json`)
            .then(res => res.json())
            .then((essays: Array<Essay>) => {
                // console.log("Successfully loaded /essays/index.json", essays)
                if (!essayList) {
                    setEssayList(essays);
                }
            })
            .catch((reason: any) => {
                console.error(`Failed to load /essays/index.json: ${reason}`)
                setEssayList([]);
            })
    } else {
        essayList.forEach((e:Essay)=>{
            if (e.slug === props.match.params.slug){
                if (!currentEssay || currentEssay.slug !== e.slug){
                    setCurrentEssay(e);
                }
            }
        })
    }

    // console.log("Slug", props.match.params.slug);
    const img = currentEssay ? currentEssay.img : undefined;
    return (
        <main className="EssayPage">
            <div className="content half">
                <div className="inner">
                    <EssayMenu
                        activeSlug={props.match.params.slug}
                        essays={essayList || []} />
                    <EssayContent
                        setEssay={setCurrentEssay}
                        slug={props.match.params.slug} />
                </div>
            </div>
            <EssayHero img={img}/>
        </main>
    )
}